import { Button, Group, Modal, Stack, Switch, Text } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SettingPanel } from "@/features/account/ui/setting-panel";
import { nextSeason, useSeason } from "@/features/content/use-season";
import { SeasonBadge } from "@/shared/ui/season-badge";

export function SeasonPanel({ isPortalAdmin }: { isPortalAdmin: boolean }) {
	const { t } = useTranslation();
	const { season, seasonSwitch, isPending, applySeason, applySeasonSwitch } =
		useSeason();
	const [confirm, setConfirm] = useState(false);
	const pendingSeason = nextSeason(season);

	return (
		<>
			<SettingPanel
				title={t("staff.seasonTitle")}
				hint={t("staff.seasonHint")}
				prominent
			>
				<Group>
					<SeasonBadge season={season} size="lg" />
				</Group>
				{isPortalAdmin ? (
					<>
						<Button
							size="md"
							fullWidth
							variant="light"
							loading={isPending}
							onClick={() => setConfirm(true)}
						>
							{season === "summer"
								? t("staff.switchToWinter")
								: t("staff.switchToSummer")}
						</Button>
						<Switch
							checked={seasonSwitch}
							disabled={isPending}
							onChange={(event) =>
								applySeasonSwitch(event.currentTarget.checked)
							}
							label={t("staff.seasonSwitch")}
						/>
					</>
				) : (
					<Text size="sm" c="dimmed">
						{t("staff.seasonAdminOnly")}
					</Text>
				)}
			</SettingPanel>
			<Modal
				opened={confirm}
				onClose={() => setConfirm(false)}
				title={t("staff.seasonConfirmTitle")}
				centered
			>
				<Stack>
					<Text size="sm">
						{t("staff.seasonConfirmBody", {
							from: season === "summer" ? t("app.summer") : t("app.winter"),
							to:
								pendingSeason === "summer" ? t("app.summer") : t("app.winter"),
						})}
					</Text>
					<Group justify="flex-end">
						<Button variant="default" onClick={() => setConfirm(false)}>
							{t("common.cancel")}
						</Button>
						<Button
							loading={isPending}
							onClick={() => {
								applySeason(pendingSeason);
								setConfirm(false);
							}}
						>
							{t("staff.seasonConfirmAction")}
						</Button>
					</Group>
				</Stack>
			</Modal>
		</>
	);
}
